<template>
  <div class="search-page-wrapper">
    <Banner :bannerImg="Img1"></Banner>

    <!-- 面包屑 -->
    <div class="Crumbs container-fixed">
      <div>
        当前位置：<router-link to="/">首页</router-link> &gt;
        <span>站内搜索</span>
      </div>
    </div>

    <main class="main-content container-fixed">
      <!-- 搜索头部 -->
      <section class="search-header-box card-modern">
        <div class="search-input-wrapper">
          <el-input
            placeholder="请输入关键词，搜索公告、新闻、资料等..."
            v-model="keyworder"
            clearable
            @keyup.enter.native="getSeach"
          >
            <el-button
              slot="append"
              type="primary"
              icon="el-icon-search"
              @click="getSeach"
            >
              搜索
            </el-button>
          </el-input>
        </div>

        <div class="search-tabs-wrapper">
          <el-tabs
            v-model="activeName"
            @tab-click="tabChange"
            class="custom-tabs"
          >
            <el-tab-pane label="全部结果" name="0"></el-tab-pane>
            <el-tab-pane label="采购公告" name="1"></el-tab-pane>
            <el-tab-pane label="采购意向" name="2"></el-tab-pane>
            <el-tab-pane label="新闻资讯" name="3"></el-tab-pane>
            <el-tab-pane label="通知公告" name="4"></el-tab-pane>
          </el-tabs>
        </div>
      </section>

      <!-- 搜索结果列表 -->
      <section class="results-section">
        <div class="results-container card-modern" v-loading="loading">
          <div
            class="result-item"
            v-for="item in searchData"
            :key="item.id"
            @click="toTager(item)"
          >
            <div class="result-header">
              <span class="category-tag">{{
                getCategoryName(item.tmpCategory)
              }}</span>
              <h2 v-html="item.title" class="result-title"></h2>
            </div>
            <div
              v-if="item.content"
              v-html="item.content"
              class="result-desc"
            ></div>
            <div class="result-footer">
              <span class="view-link"
                >查看详情 <i class="el-icon-right"></i
              ></span>
            </div>
          </div>

          <el-empty
            v-if="!loading && searchData.length === 0"
            description="未找到相关结果，请尝试更换关键词"
          />
        </div>

        <div
          class="pagination-wrapper"
          v-if="pagination.total > pagination.size"
        >
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.current"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pagination.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total"
          >
          </el-pagination>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import article from "@/api/article";
import Banner from "../components/banners.vue";

export default {
  name: "SearchPage",
  components: {
    Banner,
  },
  data() {
    return {
      Img1: require("@/assets/images/banner1.png"),
      activeName: "0",
      loading: false,
      pagination: {
        total: 0,
        size: 10,
        current: 1,
      },
      searchData: [],
      keyworder: "",
    };
  },
  created() {
    this.keyworder = this.$route.params.name || "";
    this.getsearchList();
  },
  methods: {
    getSeach() {
      this.pagination.current = 1;
      this.getsearchList();
    },
    getsearchList() {
      if (!this.keyworder.trim() && this.activeName === "0") {
        this.searchData = [];
        this.pagination.total = 0;
        return;
      }

      this.loading = true;
      let params = {
        size: this.pagination.size,
        current: this.pagination.current,
        query_key_like: this.keyworder,
      };

      if (this.activeName && this.activeName != "0") {
        params.category = this.activeName;
      }

      article.searchList(params).then(
        (res) => {
          let data = res.data.data;
          this.searchData = this.setDataList(
            data.records || [],
            this.keyworder || "",
          );
          this.pagination.total = data.total;
          this.loading = false;
        },
        (error) => {
          console.error(error);
          this.loading = false;
        },
      );
    },
    setDataList(list, keyWord) {
      return list.map((item) => {
        if (item.tmpCategory == "3") {
          item.title = item.newsTitle;
          item.content = item.remark;
        }
        // 高亮逻辑
        if (keyWord) {
          const reg = new RegExp(keyWord, "gi");
          if (item.title) {
            item.title = item.title.replace(
              reg,
              `<span style="color:#f84c21;">${keyWord}</span>`,
            );
          }
          if (item.content) {
            item.content = item.content.replace(
              reg,
              `<span style="color:#f84c21;">${keyWord}</span>`,
            );
          }
        }
        return item;
      });
    },
    getCategoryName(cat) {
      const map = {
        1: "采购公告",
        2: "采购意向",
        3: "新闻资讯",
        4: "通知公告",
        manuals: "操作手册",
      };
      return map[cat] || "其他";
    },
    toTager(row) {
      let routeData;
      const articleId = row.articleId;
      const id = row.id;

      switch (row.tmpCategory) {
        case "1":
          routeData = {
            path: "/listinfo",
            query: { articleId },
          };
          break;
        case "2":
          routeData = {
            path: "/tableinfo",
            query: { articleId },
          };
          break;
        case "3":
          routeData = {
            path: "/newsdetal",
            query: { id },
          };
          break;
        case "4":
          routeData = {
            path: "/noticedetail",
            query: { id },
          };
          break;
        case "manuals":
          routeData = {
            path: "/imgecourse",
            query: { id },
          };
          break;
      }
      if (routeData) this.$router.push(routeData);
    },
    handleSizeChange(val) {
      this.pagination.size = val;
      this.getsearchList();
    },
    handleCurrentChange(val) {
      this.pagination.current = val;
      this.getsearchList();
    },
    tabChange() {
      this.pagination.current = 1;
      this.getsearchList();
    },
  },
};
</script>

<style lang="less" scoped>
@import "../assets/styles/variables.less";

.search-page-wrapper {
  background-color: @bg-base;
}

.Crumbs {
  padding: 20px 0;
  font-size: 14px;
  color: @text-secondary;
  span {
    color: @text-main;
    font-weight: 500;
  }
  a:hover {
    color: @primary-color;
  }
}

.main-content {
  padding-bottom: 80px;
}

.search-header-box {
  background: #fff;
  padding: 40px;
  margin-bottom: 32px;
}

.search-input-wrapper {
  max-width: 800px;
  margin: 0 auto 32px;

  /deep/ .el-input-group__append {
    background-color: @primary-color;
    border-color: @primary-color;
    color: #fff;
    padding: 0 32px;
    font-weight: 600;

    .el-button {
      color: #fff;
    }
  }

  /deep/ .el-input__inner {
    height: 54px;
    line-height: 54px;
    font-size: 16px;
  }
}

.search-tabs-wrapper {
  .custom-tabs {
    /deep/ .el-tabs__nav-wrap::after {
      display: none;
    }
    /deep/ .el-tabs__header {
      margin: 0;
    }
    /deep/ .el-tabs__nav {
      width: 100%;
      display: flex;
      justify-content: center;
      gap: 40px;
    }
    /deep/ .el-tabs__item {
      font-size: 16px;
      height: 40px;
      line-height: 40px;
      padding: 0 !important;
    }
  }
}

.results-container {
  background: #fff;
  padding: 20px 40px;
  min-height: 400px;
}

.result-item {
  padding: 32px 0;
  border-bottom: 1px solid #f1f5f9;
  cursor: pointer;
  transition: all 0.3s;

  &:last-child {
    border-bottom: none;
  }

  .result-header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 16px;

    .category-tag {
      font-size: 12px;
      padding: 2px 8px;
      background: @primary-light;
      color: @primary-color;
      border-radius: 4px;
      font-weight: 500;
    }

    .result-title {
      font-size: 20px;
      font-weight: 600;
      color: @text-main;
      transition: color 0.3s;
    }
  }

  .result-desc {
    font-size: 15px;
    color: @text-secondary;
    line-height: 1.8;
    margin-bottom: 16px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .result-footer {
    .view-link {
      font-size: 14px;
      color: @primary-color;
      display: flex;
      align-items: center;
      gap: 4px;
      opacity: 0;
      transform: translateX(-10px);
      transition: all 0.3s;
    }
  }

  &:hover {
    .result-title {
      color: @primary-color;
    }
    .result-footer .view-link {
      opacity: 1;
      transform: translateX(0);
    }
  }
}

.pagination-wrapper {
  margin-top: 40px;
  display: flex;
  justify-content: center;
}
</style>
